import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppShell } from '../components/AppShell'
import { ParentShell } from '../components/ParentShell'
import { ChatView } from '../components/ChatView'
import { useAuth } from '../auth/AuthContext'

/** Чат для учителя (использует AppShell). */
export function ChatPage() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  return (
    <AppShell title={t('chatPage.teacherTitle')} subtitle={t('chatPage.teacherSubtitle')}>
      <ChatView
        peerLabel={t('chatPage.peerParent')}
        emptyHint={t('chatPage.teacherEmptyHint')}
        initialThreadId={params.get('thread') ?? undefined}
      />
    </AppShell>
  )
}

/** Чат для родителя (использует ParentShell). */
export function ParentChatPage() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const { teacher } = useAuth()
  if (!teacher) return null
  return (
    <ParentShell title={t('chatPage.parentTitle')} subtitle={t('chatPage.parentSubtitle')}>
      <ChatView
        peerLabel={t('chatPage.peerTeacher')}
        emptyHint={t('chatPage.parentEmptyHint')}
        initialThreadId={params.get('thread') ?? undefined}
      />
    </ParentShell>
  )
}
